module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Da-Ge-Ha-Ib-Jb.4c359917.png";